import Courses from "../components/Courses";

const Home = () => {
  return <Courses />;
};

export default Home;
